module.exports = __webpack_public_path__ + "media/images/landing/illust/graph-categories-583e79aa502d955647be01de549e84e1.png";